import { Component, Input } from '@angular/core';
import { Exhibitor, Product } from '@planone/bau365/util-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { ImageFileTypes } from '@planone/shared/util-pipelines';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'bau365-product-section-exhibitor-info',
  templateUrl: './section-exhibitor-info.component.html',
  styleUrls: ['./section-exhibitor-info.component.scss'],
})
export class SectionProductExhibitorInfoComponent {
  @Input() product?: Product;
  @Input() exhibitor?: Exhibitor;
  @Input() size?: string;
  @Input() locationClickable = true;
  @Input() exhibitorClickable = true;

  hallPlanToggle$: Observable<boolean | undefined>;

  ImageFileTypes = ImageFileTypes;

  constructor(public togglesFacade: DataAccessTogglesFacade) {
    this.hallPlanToggle$ = togglesFacade.flag('kill-hall-plan').pipe(map((hallplanDisabled) => !hallplanDisabled));
  }
}
